import React from "react";
import _ from "lodash";
import autoBind from "react-autobind";
import Select from "react-select";

class PlayerPickerDropdownFilter extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	onChange(event) {
		let value, label;

		if (event !== null) {
			value = event.value;
			label = event.label;
		} 

		if (this.props.onChange) {
			this.props.onChange(value,label);
		}
	}

	render() {

		const { item, placeholder, options, disabled } = this.props;

		let entries = [];


		let selectedOption;
		_.each(options, (pickerItem, idx) => {
			entries.push({ value: pickerItem.value, label: pickerItem.label });
			if (pickerItem.value === item.value) {
				selectedOption = pickerItem;
			}
		});

		return <Select isDisabled={disabled} placeholder={placeholder} options={entries} onChange={this.onChange} value={selectedOption} />;
	}
}

export default PlayerPickerDropdownFilter;